module.exports = __webpack_public_path__ + "img/ico_doutor-favorito.9a0fe297.svg";